import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { get } from 'lodash'

import PostIt from 'components/molecules/PostIt'

import './PostIts.scss'

function PostIts({ data }) {
  const items = get(data, 'items')

  return (
    <div className={`post-its ${get(data, 'theme.entity.classes')}`}>
      <Container>
        <Row>
          {items &&
            items.map(({ entity }) => (
              <Col xs={12} md={4} className="mb-4">
                <PostIt
                  title={get(entity, 'title')}
                  date={get(entity, 'date.value')}
                  themeClasses={get(entity, 'theme.entity.classes')}
                  icon={get(entity, 'icon.entity.media.entity.fieldMediaFile.entity.url')}
                />
              </Col>
            ))}
        </Row>
      </Container>
    </div>
  )
}

export default PostIts
